/**
 * Client-admin roles stored on `clientUsers.role`.
 *
 * The column is free-text. The backend accepts both the historical `'ADMIN'`
 * spelling and `'ClientAdmin'` (`authorization.ts`). Matching only one of them
 * here would hide locations and cages in Quick Search (and the sidebar)
 * for anyone stored as the other spelling.
 */
export function isClientAdminRole(role: string): boolean {
    return role === 'ADMIN' || role === 'ClientAdmin';
}
